
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.46 4a.24.24 0 01.24.24v1.015a.24.24 0 01-.24.24h-.574a.24.24 0 00-.217.14l-.93 2.001h10.417l-.617-1.972a.24.24 0 00-.229-.169h-.55a.24.24 0 01-.24-.24V4.24a.24.24 0 01.24-.24h.763c.654 0 1.292.196 1.834.563l3.61 2.447A2.352 2.352 0 0123 8.958v8.837A2.205 2.205 0 0120.795 20h-5.35c-.657 0-1.28-.293-1.7-.8l-1.179-1.424a.735.735 0 00-1.132 0L10.255 19.2c-.419.507-1.042.8-1.7.8h-5.35A2.205 2.205 0 011 17.795V8.96c0-.782.389-1.513 1.037-1.95l3.569-2.408A3.529 3.529 0 017.579 4h.881zm.737 7.044h-4.76a1.47 1.47 0 00-1.47 1.47v2.242c0 .812.658 1.47 1.47 1.47h4.76a1.47 1.47 0 001.47-1.47v-2.242a1.47 1.47 0 00-1.47-1.47zm10.31 0h-4.759a1.47 1.47 0 00-1.47 1.47v2.242c0 .812.658 1.47 1.47 1.47h4.76a1.47 1.47 0 001.47-1.47v-2.242a1.47 1.47 0 00-1.47-1.47z","id":"🎨-Color","fill":"currentColor","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}})])
          )
        }
      }
    